import { Box } from '@mui/material';
import React from 'react';
import '../styles/components/_course-progress-bar.scss';
import { TrophyIcon } from '../utils/icons';

export type CourseProgressBarSize = 'detail' | 'sidebar';

interface CourseProgressBarProps {
  progress: number;
  size?: CourseProgressBarSize;
  className?: string;
}

const CourseProgressBar: React.FC<CourseProgressBarProps> = ({
  progress,
  size = 'detail',
  className = '',
}) => {
  const pct = Math.round(Number(progress ?? 0));
  const iconSize = size === 'sidebar' ? 12 : 20;

  return (
    <Box
      className={`course-progress-bar course-progress-bar--${size}${
        className ? ` ${className}` : ''
      }`}
    >
      <Box className="course-progress-bar__track">
        {pct > 0 && (
          <Box
            className={`course-progress-bar__fill${
              pct >= 100 ? ' course-progress-bar__fill--full' : ''
            }`}
            style={{
              width: `${pct}%`,
              ...(pct < 15 ? { minWidth: '52px' } : {}),
            }}
          >
            <span className="course-progress-bar__percent">{pct}%</span>
          </Box>
        )}
      </Box>
      <Box className="course-progress-bar__badge" aria-hidden="true">
        <TrophyIcon
          size={iconSize}
          className="course-progress-bar__badge-icon"
          strokeWidth={2}
        />
      </Box>
    </Box>
  );
};

export default CourseProgressBar;
